const initial_filters = {
  type: {
    name: "Quel type de bien ?",
    data: [],
    id: "type",
  },
  usage: {
    name: "Pour quel usage ?",
    data: [],
    id: "usage",
  },
  environnement: {
    name: "Dans quel environnement ?",
    data: [],
    id: "environnement",
  },
  etat: {
    name: "Quel état du bien ?",
    data: [],
    id: "etat",
  },
  style: {
    name: "Quel style dominant ?",
    data: [],
    id: "style",
  },
};

const state = {
  filters: {
    type: {
      name: "Quel type de bien ?",
      data: [],
      id: "type",
    },
    usage: {
      name: "Pour quel usage ?",
      data: [],
      id: "usage",
    },
    environnement: {
      name: "Dans quel environnement ?",
      data: [],
      id: "environnement",
    },
    etat: {
      name: "Quel état du bien ?",
      data: [],
      id: "etat",
    },
    style: {
      name: "Quel style dominant ?",
      data: [],
      id: "style",
    },
  },
};

const mutations = {
  ADD_ENVIRONNEMENT(state, value) {
    state.filters.environnement.data.push(value);
  },
  SET_ENVIRONNEMENT(state, value) {
    state.filters.environnement.data = value;
  },
  ADD_ETAT(state, value) {
    state.filters.etat.data.push(value);
  },
  SET_ETAT(state, value) {
    state.filters.etat.data = value;
  },
  ADD_STYLE(state, value) {
    state.filters.style.data.push(value);
  },
  SET_STYLE(state, value) {
    state.filters.style.data = value;
  },
  ADD_TYPE(state, value) {
    state.filters.type.data.push(value);
  },
  SET_TYPE(state, value) {
    state.filters.type.data = value;
  },
  ADD_USAGE(state, value) {
    state.filters.usage.data.push(value);
  },
  SET_USAGE(state, value) {
    state.filters.usage.data = value;
  },
  CLEAR_DATA(state) {
    state.filters = initial_filters;
  },
};

const getters = {
  getData: (state) => {
    return state.filters;
  },
};

const actions = {
  async fetchData({ commit }) {
    commit("CLEAR_DATA");
    var json = require(`@/assets/json/data.json`);
    commit("SET_ENVIRONNEMENT", json.environnement);
    commit("SET_ETAT", json.etat);
    commit("SET_STYLE", json.style);
    commit("SET_TYPE", json.type);
    commit("SET_USAGE", json.usage);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
